<template>
  <div class="rect__title">
    <div class="d-flex justify-content-start">
      <Controls
        :currentDate="currentDate"
        :isEnabled="isEnabled"
        :lastValues="lastValues"
        :selectedPeriod="selectedPeriod"
        @setCurrentDate="setCurrentDate"
        :key="currentDate.getTime()"
      />
      <h1 v-if="isEnabled">
        {{ currentPeriod }}
      </h1>
      <h1 v-else>Test Chat is not enabled.</h1>
    </div>
    <div class="d-flex justify-content-end toggle-wrapper align-self-start">
      <button :class="`btn small duration-toggle ${selectedPeriod == 'daily' ? 'btn--purple gradient' : 'btn--white'}`" @click="togglePeriod('daily')">
        Daily
      </button>
      <button :class="`btn small duration-toggle ${selectedPeriod == 'monthly' ? 'btn--purple gradient' : 'btn--white'}`" @click="togglePeriod('monthly')">
        Monthly
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { months } from '@common/constants/time.constant'
import Controls from '../analytics/Controls.vue'

@Component({
  components: {Controls}
})
export default class StatisitcsTimeSelector extends Vue {
  private currentDate = new Date()
  private selectedPeriod: 'daily' | 'monthly' = 'monthly'

  @Prop({ default: false }) readonly isEnabled: boolean
  @Prop({ default: {} }) readonly lastValues: object

  togglePeriod(selectedPeriod: 'daily' | 'monthly') {
    this.selectedPeriod = selectedPeriod
    this.$emit('update:selectedPeriod', selectedPeriod)
  }

  async setCurrentDate(date: Date) {
    this.currentDate = date
    this.$emit('update:currentDate', date)
  }

  get currentPeriod() {
    return this.selectedPeriod == 'monthly'
      ? `${months[this.currentDate.getMonth()]} ${this.currentDate.getFullYear()}`
      : `${this.currentDate.getDate()} ${months[this.currentDate.getMonth()]} ${this.currentDate.getFullYear()}`
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/scss/variables';

.rect {

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .container__date-wrapper + h1 {
      margin-left: 20px;
    }
  }
}

.rect__title {
  color: white;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  color: white;
  line-height: 28px;
  margin: 0;

  span {
    font-size: 14px;
  }
}

.toggle-wrapper {
  :first-child {
    border-radius: 6px 0 0 6px;
  }

  :last-child {
    border-radius: 0 6px 6px 0;
  }

  .duration-toggle {
    margin-left: 0;
    border: none;
    background-color: $main;
    color: white;
    transition: all 0.3s ease;

    &.btn--white {
      color: $main;
      background-color: #ffffff;
    }
  }
}
</style>
